import type { List } from '@gonfalon/immutable-shim/immutableShim';
import { Map } from '@gonfalon/immutable-shim/immutableShim';

import { type DeniedAccess } from './types';

export function newAccessDeniesAction(oldAccess: List<DeniedAccess>, newAccess: List<DeniedAccess>, action: string) {
  const oldAccessMap = Map(oldAccess.map((i) => [i.get('action'), i.get('reason')]));
  const newAccessMap = Map(newAccess.map((i) => [i.get('action'), i.get('reason')]));
  return newAccessMap.has(action) && !oldAccessMap.has(action);
}
